import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/profil.png'


const _withScopeId = n => (_pushScopeId("data-v-17c66384"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "left-side-profil-container p-3" }
const _hoisted_2 = {
  class: "left-side-profil flex flex-column overflow-auto pb-4",
  style: {"width":"323px"}
}
const _hoisted_3 = { class: "flex ml-3 mt-4" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "profil-img",
  src: _imports_0,
  alt: "profil-picture"
}
const _hoisted_6 = { class: "flex ml-3 mt-2" }
const _hoisted_7 = { class: "font-normal m-0" }
const _hoisted_8 = { class: "flex ml-3 mt-2" }
const _hoisted_9 = { class: "color-tag text-white app-label-micro uppercase bg-primary-blue" }
const _hoisted_10 = { class: "flex ml-3 mt-2" }
const _hoisted_11 = { class: "flex app-label-small text-gray-l1" }
const _hoisted_12 = { class: "flex ml-3 mt-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line-section-gray mt-4",
  style: {"border":"1px solid #eaeef0"}
}, null, -1))
const _hoisted_14 = { class: "flex ml-3 mt-3" }
const _hoisted_15 = { class: "flex app-label-small text-gray-l1 font-bold uppercase" }
const _hoisted_16 = { class: "flex ml-3 mt-3" }
const _hoisted_17 = { class: "flex app-label-small text-gray-D1 font-bold" }
const _hoisted_18 = { class: "flex ml-3 mt-1" }
const _hoisted_19 = { class: "flex app-label-small text-gray-l1" }
const _hoisted_20 = { class: "flex ml-3 mt-1" }
const _hoisted_21 = { class: "flex ml-3 mt-3" }
const _hoisted_22 = { class: "flex app-label-small text-gray-D1 font-bold" }
const _hoisted_23 = { class: "flex ml-3 mt-1" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex app-label-small text-gray-l1 font-bold" }, "pro"),
  /*#__PURE__*/_createElementVNode("div", { class: "flex app-label-small text-gray-l1 font-bold" }, "perso")
], -1))
const _hoisted_25 = { class: "flex app-label-small text-gray-l1" }
const _hoisted_26 = { class: "flex app-label-small text-gray-l1" }
const _hoisted_27 = { class: "flex ml-3 mt-1" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line-section-gray mt-4",
  style: {"border":"1px solid #eaeef0"}
}, null, -1))
const _hoisted_29 = { class: "flex ml-3 mt-2" }
const _hoisted_30 = { class: "flex app-label-small text-gray-l1 font-bold uppercase" }
const _hoisted_31 = { class: "flex mt-3 justify-content-between flex-wrap ml-3 mr-3" }
const _hoisted_32 = { class: "flex flex-column" }
const _hoisted_33 = { class: "flex app-label-small text-default-gray font-bold" }
const _hoisted_34 = { class: "flex app-label-small text-default-gray font-bold mt-3" }
const _hoisted_35 = { class: "flex app-label-small text-default-gray font-bold mt-3" }
const _hoisted_36 = { class: "flex app-label-small text-default-gray font-bold mt-3" }
const _hoisted_37 = { class: "flex app-label-small text-default-gray font-bold mt-3" }
const _hoisted_38 = { class: "flex app-label-small text-default-gray font-bold mt-3" }
const _hoisted_39 = { class: "flex app-label-small text-default-gray font-bold mt-3" }
const _hoisted_40 = { class: "flex flex-column align-items-end" }
const _hoisted_41 = { class: "flex app-label-small text-default-gray font-bold" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "flex app-label-small text-default-gray font-bold mt-3" }, " 1 ", -1))
const _hoisted_43 = { class: "flex app-label-small text-default-gray font-bold mt-3" }
const _hoisted_44 = { class: "flex app-label-small text-default-gray font-bold mt-3" }
const _hoisted_45 = { class: "flex app-label-small text-default-gray font-bold mt-3" }
const _hoisted_46 = { class: "flex app-label-small text-default-gray font-bold mt-3" }
const _hoisted_47 = { class: "flex app-label-small text-default-gray font-bold mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_button = _resolveComponent("app-button")!
  const _component_EmailChangeDialog = _resolveComponent("EmailChangeDialog")!
  const _component_PasswordChangeDialog = _resolveComponent("PasswordChangeDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.user.picture_url)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "profil-img",
              src: _ctx.user.picture_url,
              alt: "profil-picture"
            }, null, 8, _hoisted_4))
          : (_openBlock(), _createElementBlock("img", _hoisted_5))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.userFullName), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.userLicense), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("span", _hoisted_11, " Dernière connexion le " + _toDisplayString(_ctx.lastLoginDate), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_app_button, {
          buttonType: "secondary",
          buttonSize: "m",
          isDisabled: false,
          iconName: "ci-action-edit",
          buttonText: _ctx.$t('homeview.profil-left-bar.edit-profil-button'),
          onClick: _ctx.editUserProfile
        }, null, 8, ["buttonText", "onClick"])
      ]),
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('homeview.profil-left-bar.settings-account-title')), 1)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('homeview.profil-left-bar.email')), 1)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.user.email), 1)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("span", {
          class: "flex app-label-micro text-primary-blue uppercase cursor-pointer",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeEmail && _ctx.changeEmail(...args)))
        }, _toDisplayString(_ctx.$t('homeview.profil-left-bar.update-email')), 1)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('homeview.profil-left-bar.phone-number')), 1)
      ]),
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.user.pro_phone || 'non renseigné'), 1),
          _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.user.perso_phone || 'non renseigné'), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("span", {
          class: "flex app-label-micro text-primary-blue uppercase cursor-pointer",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.editUserProfile && _ctx.editUserProfile(...args)))
        }, _toDisplayString(_ctx.$t('homeview.profil-left-bar.update-phone-number')), 1)
      ]),
      _hoisted_28,
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t('homeview.profil-left-bar.summary-title')), 1)
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('homeview.profil-left-bar.subscription')), 1),
          _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t('homeview.profil-left-bar.buildings')), 1),
          _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t('homeview.profil-left-bar.zones')), 1),
          _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t('homeview.profil-left-bar.objects')), 1),
          _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t('homeview.profil-left-bar.tags')), 1),
          _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t('homeview.profil-left-bar.gateways')), 1),
          _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t('homeview.profil-left-bar.shares')), 1)
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.getSub()), 1),
          _hoisted_42,
          _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.nbZones), 1),
          _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.nbIts), 1),
          _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.nbTags), 1),
          _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.nbGateways), 1),
          _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.nbAuths), 1)
        ])
      ])
    ]),
    _createVNode(_component_EmailChangeDialog, { ref: "emailChangeDialog" }, null, 512),
    _createVNode(_component_PasswordChangeDialog, { ref: "passwordChangeDialog" }, null, 512)
  ]))
}